<div [ngClass]="{'visible': visible()}">
    <div class="dialog" [ngStyle]="{'animation-duration': duration + 'ms'}">
        <div class="header">
            <h1 class="modal-title"><ng-content select="[modal-header]"></ng-content></h1>
            <button [id]="id() + '-close'" (click)="toggle()">&times;</button>
        </div>
        <div class="body">  
            <ng-content select="[modal-body]"></ng-content>
        </div>
        <div class="footer" #footer [ngClass]="{'visible': footerPresent}">
            <ng-content select="[modal-footer]"></ng-content>
        </div>
    </div>
</div>